export default "__VITE_ASSET__CYq1qeb___"